import React from 'react';
import person from '../images/profile_img.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faGithub, faLinkedin, faTwitter, faStackOverflow } from '@fortawesome/free-brands-svg-icons'
import resume from '../MRamzan_v10.pdf'

export default function Banner() {

  return (
    <div className="banner" id="home">     
      <div className="container">
        <div className="row">
            <div className="col-md-6 home-dtls">
              <div>
                <h2>Muhammad Ramzan Nawab</h2>
                <p>
                  Hi, I am a <b>RoR Full Stack developer</b> with experience of 5+ years.
                  worked in multiple domains of Web App development, <span title='Application Programming Interface'>APIs</span>, <span title='Progressive Web App'>PWA</span>, <span title="Development and operation">DevOps</span>, <span title='Web Accessibility Initiative – Accessible Rich Internet Applications'>WAI-ARIA</span>,
                  Web Crawling and Scraping <sup>legitimately</sup>. I believe that <q><i>With diversity one can give better solutions</i></q>.
                </p>
              </div>
              <div className="social mt-2">
                <a className="link-color" href="https://www.linkedin.com/in/mr-muhammadramzan" target="_blank" title='LinkedIn Profile'>
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a className="link-color" href="https://github.com/MrMRamzan" target="_blank" title='GitHub Profile'>
                  <FontAwesomeIcon icon={faGithub} />
                </a>
                <a className="link-color" href="https://stackoverflow.com/users/9342156/mr-muhammad-ramzan" target="_blank" title='Stack Overflow Profile'>
                  <FontAwesomeIcon icon={faStackOverflow} />
                </a>
                {/* <a className="link-color" href="javascript:void();" title='Twitter Profile'>
                  <FontAwesomeIcon icon={faTwitter} />
                </a> */}
                {/* <a className="link-color" href="javascript:void();" title='Facebook Profile'>
                  <FontAwesomeIcon icon={faFacebook} />
                </a> */}
              </div>
              <div className="resume mt-2">
                <button className="btn"><a href={resume} target="_blank" rel="noopener noreferrer" download="MRamzan.pdf">Download Resume</a></button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="home-sec">
                <img alt="" src={person}/>
              </div>
            </div>
        </div>
      </div>
    </div>
   )
}
